import { render } from "./Ipv6FirewallRulesTab.vue?vue&type=template&id=1cd50277&scoped=true"
import script from "./Ipv6FirewallRulesTab.vue?vue&type=script&lang=js"
export * from "./Ipv6FirewallRulesTab.vue?vue&type=script&lang=js"

import "./Ipv6FirewallRulesTab.vue?vue&type=style&index=0&id=1cd50277&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd50277"]])

export default __exports__